// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__dETEq","label_disabled":"Label_label_disabled__1V8Cy"};